import React from "react";
import { getIcon } from "../../../utils/images";
import "./ArchiveHeader.scss";
import { useNavigate } from "react-router-dom"; 

const ArchiveHeader = ({}) => {
  const navigate = useNavigate()

  function redirectToHomePage() {
    navigate("/shipment_management")
  }

  return (
    <div className="ArchiveHeader">
      <img src={getIcon('back-arrow')} onClick={redirectToHomePage} />
      <div className="title">
        Archive
      </div>
    </div>
  )
}

export default ArchiveHeader;
